import { Store, Clock, Hash, ShieldCheck } from 'lucide-react';
import { useCashSession } from '../../hooks/cash/useCashSession';

const CashStatusCard = () => {

  const { activeSession, openingForm } = useCashSession();

  const isOpen = activeSession?.opened ?? activeSession?.status === 'OPEN';

  const formatDateTime = (date?: string) => {
    if (!date) return '—';
    const d = new Date(date);
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
  };

  const terminalLabel = activeSession?.registerName
    ? `${activeSession.branchName ?? ''}${
        activeSession.branchName ? ' · ' : ''
      }${activeSession.registerName}`
    : openingForm.registerId
    ? `Terminal #${openingForm.registerId}`
    : 'No seleccionada';

  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-stroke px-6 py-4 dark:border-strokedark">

        <div className="flex items-center gap-2">
          <ShieldCheck size={16} className="text-primary" />
          <h3 className="text-sm font-medium text-black dark:text-white">
            Estado de Caja
          </h3>
        </div>

        <span className={`
          inline-flex rounded px-2 py-0.5 text-xs font-medium text-white
          ${isOpen ? 'bg-[#3CA745]' : 'bg-[#DC3545]'}
        `}>
          {isOpen ? 'ABIERTA' : 'CERRADA'}
        </span>

      </div>

      {/* BODY */}
      <div className="p-6 space-y-5">

        {/* ESTADO PRINCIPAL */}
        <div className="flex items-center gap-3">

          <div className={`
            flex h-10 w-10 items-center justify-center rounded-md
            ${isOpen ? 'bg-[#3CA745]/10 text-[#3CA745]' : 'bg-[#DC3545]/10 text-[#DC3545]'}
          `}>
            <ShieldCheck size={18} />
          </div>

          <div>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Estado actual
            </p>

            <p className="text-base font-semibold text-black dark:text-white">
              {isOpen ? 'Caja abierta' : 'Caja cerrada'}
            </p>
          </div>

        </div>

        {/* INFO LIST */}
        <div className="space-y-3 text-sm">

          <Row
            icon={<Store size={16} />}
            label="Terminal"
            value={terminalLabel}
          />

          <Row
            icon={<Hash size={16} />}
            label="Sesión"
            value={activeSession?.sessionNumber ?? '—'}
            breakAll
          />

          <Row
            icon={<Clock size={16} />}
            label={isOpen ? 'Apertura' : 'Último cierre'}
            value={
              isOpen
                ? formatDateTime(activeSession?.openedAt)
                : formatDateTime(activeSession?.closedAt)
            }
          />

        </div>

      </div>

    </div>

  );

};

export default CashStatusCard;


/**
 * 🔹 FILA MODERNA (SIN BLOQUES PESADOS)
 */
const Row = ({ icon, label, value, breakAll }: any) => {

  return (

    <div className="flex items-start justify-between gap-3">

      {/* LEFT */}
      <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
        {icon}
        <span className="text-xs">{label}</span>
      </div>

      {/* RIGHT */}
      <span className={`
        text-xs font-medium text-black dark:text-white text-right
        ${breakAll ? 'break-all' : 'truncate'}
      `}>
        {value}
      </span>

    </div>

  );

};